const AUDIO_MESSAGE_NAME_MAX_LENGTH = 17
const AUDIO_MESSAGE_BUTTON_CAPTION_MAX_LENGTH = 9
const AUDIO_MESSAGE_MAX_DURATION = 5 * 60

export {
  AUDIO_MESSAGE_MAX_DURATION,
  AUDIO_MESSAGE_NAME_MAX_LENGTH,
  AUDIO_MESSAGE_BUTTON_CAPTION_MAX_LENGTH,
}
